var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"rosters-pages"}},[_c('router-view',_vm._g(_vm._b({},'router-view',_vm.dataBind,false),_vm.eventBind))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }